export default "__VITE_ASSET__CIB0uuI0__"